export const LARGE_OPTIMIZATION_MAX_SERVICES = 1000;

export type StopStatus = `pending` | `incomplete` | `completed` | `canceled`;

export const STOP_STATUS = {
  pending: `pending`,
  canceled: `canceled`,
  completed: `completed`,
  incomplete: `incomplete`,
} as Record<StopStatus, StopStatus>;

export type StopTaskStatus = `pending` | `completed` | `canceled`;

export const STOP_TASK_STATUS = {
  pending: `pending`,
  canceled: `canceled`,
  completed: `completed`,
} as Record<StopTaskStatus, StopTaskStatus>;

export type ReportStatus = `completed` | `incomplete` | `canceled`;

export const STOP_REPORT_STATUS = {
  completed: `completed`,
  incomplete: `incomplete`,
  canceled: `canceled`,
} as Record<ReportStatus, ReportStatus>;
